import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/browser';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: environment.SENTRY_DNS,
  });

  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
bootstrap().catch(err => console.error(err));
